const getGlobalSystemNotificationSettings = () => `
  *[_type == "global_system_notification_settings" ] {
    _id,
    boolean,
    text
  }
`;

export default getGlobalSystemNotificationSettings;
